import styled from 'styled-components';

export const Header = styled.div`
    border-bottom: 1px solid #e2e8f0;
`;

export const Body = styled.div`
    padding: 16px;
    display: flex;
    flex-direction: column;
    gap: 12px;

    .product {
        .name { font-size: 13px; font-weight: 700; color: #0f172a; }
        .option { font-size: 12px; color: #64748b; margin-top: 2px; }
    }

    .summary {
        display: flex;
        flex-wrap: wrap;
        gap: 6px;

        span {
            display: inline-flex;
            align-items: center;
            gap: 3px;
            padding: 3px 8px;
            border-radius: 999px;
            font-size: 11px;
            font-weight: 600;
            background: #f1f5f9;
            color: #475569;

            b { font-size: 12px; font-weight: 800; color: #0f172a; }
        }

        span.max {
            background: #eff6ff;
            color: #2563eb;
            b { color: #2563eb; }
        }
    }

    .guide {
        font-size: 12px;
        font-weight: 700;
        color: #2563eb;
    }

    .inputRow {
        display: flex;
        align-items: center;
        gap: 8px;

        input {
            flex: 1;
            height: 46px;
            border: 1px solid #cbd5e1;
            border-radius: 10px;
            padding: 0 12px;
            font-size: 20px;
            font-weight: 800;
            color: #0f172a;
            text-align: center;
            outline: none;

            &:focus { border-color: #2563eb; box-shadow: 0 0 0 3px rgba(37, 99, 235, .12); }

            /* 숫자 입력 스피너 제거 (터치 작업 환경) */
            &::-webkit-outer-spin-button,
            &::-webkit-inner-spin-button { -webkit-appearance: none; margin: 0; }
            -moz-appearance: textfield;
        }

        .unit { font-size: 13px; font-weight: 700; color: #64748b; }
    }

    .quickRow {
        display: flex;
        flex-wrap: wrap;
        gap: 6px;

        button {
            flex: 1;
            min-width: 56px;
            height: 38px;
            border: 1px solid #dbeafe;
            border-radius: 10px;
            background: #eff6ff;
            color: #2563eb;
            font-size: 13px;
            font-weight: 800;
            cursor: pointer;
            transition: all .15s;

            &:hover { background: #dbeafe; }

            &.max { background: #dcfce7; border-color: #bbf7d0; color: #16a34a; }
            &.max:hover { background: #bbf7d0; }

            &.reset { background: #f8fafc; border-color: #e2e8f0; color: #64748b; }
            &.reset:hover { background: #f1f5f9; }
        }
    }

    .actions {
        display: flex;
        gap: 8px;
        margin-top: 4px;

        button {
            flex: 1;
            height: 44px;
            border: none;
            border-radius: 10px;
            font-size: 14px;
            font-weight: 800;
        }

        .cancel { background: #f1f5f9; color: #475569; }
        .confirm { background: #2563eb; color: #fff; }
        .confirm:disabled { background: #cbd5e1; color: #fff; cursor: not-allowed; }
    }
`;
